import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { ISubjectUrlList, SubjectUrl } from '../models/subject-url';
import { IParentEntity } from '../interfaces/entity';

@Injectable({ providedIn: 'root'})
export class SubjectUrlService extends BaseRestService<SubjectUrl, ISubjectUrlList>{

  constructor(http: HttpClient, protected router: Router) {
    super(SubjectUrlService, http, 'api/subjecturls', 'URL', router);

    // enable caching
    this.cacheEnabled = false;
  }

  updateMetadata(item: SubjectUrl, metadata){
    item.url.labels = metadata[0].value;
    this.save(item);
  }
}
